/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../kubb/client";
import type { Client, RequestConfig, ResponseErrorConfig, ResponseConfig } from "../../../kubb/client";
import type { GetLeadByExternalIdQueryResponse, GetLeadByExternalIdPathParams, GetLeadByExternalId401, GetLeadByExternalId403, GetLeadByExternalId404, GetLeadByExternalId503 } from "../models/GetLeadByExternalId";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getLeadByExternalIdQueryKey = ({ externalId }: { externalId: GetLeadByExternalIdPathParams["externalId"] }) => [{ url: '/api/v1/contact/leads/by-external-id/:externalId', params: {externalId:externalId} }] as const

export type GetLeadByExternalIdQueryKey = ReturnType<typeof getLeadByExternalIdQueryKey>

/**
 * @description Returns full lead details including contact info and offer timeline for the authenticated driver. Looks up by the Lease End external deal ID instead of UUID.
 * @summary Get lead details (driver view) (by external ID)
 * {@link /api/v1/contact/leads/by-external-id/:externalId}
 */
export async function getLeadByExternalId({ externalId }: { externalId: GetLeadByExternalIdPathParams["externalId"] }, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetLeadByExternalIdQueryResponse, ResponseErrorConfig<GetLeadByExternalId401 | GetLeadByExternalId403 | GetLeadByExternalId404 | GetLeadByExternalId503>, unknown>({ method : "GET", url : `/api/v1/contact/leads/by-external-id/${externalId}`, ... requestConfig })
  return res
}

export function getLeadByExternalIdQueryOptions({ externalId }: { externalId: GetLeadByExternalIdPathParams["externalId"] }, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getLeadByExternalIdQueryKey({ externalId })
        return queryOptions<ResponseConfig<GetLeadByExternalIdQueryResponse>, ResponseErrorConfig<GetLeadByExternalId401 | GetLeadByExternalId403 | GetLeadByExternalId404 | GetLeadByExternalId503>, ResponseConfig<GetLeadByExternalIdQueryResponse>, typeof queryKey>({
         enabled: !!(externalId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getLeadByExternalId({ externalId: externalId }, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns full lead details including contact info and offer timeline for the authenticated driver. Looks up by the Lease End external deal ID instead of UUID.
 * @summary Get lead details (driver view) (by external ID)
 * {@link /api/v1/contact/leads/by-external-id/:externalId}
 */
export function useGetLeadByExternalId<TData = ResponseConfig<GetLeadByExternalIdQueryResponse>, TQueryData = ResponseConfig<GetLeadByExternalIdQueryResponse>, TQueryKey extends QueryKey = GetLeadByExternalIdQueryKey>({ externalId }: { externalId: GetLeadByExternalIdPathParams["externalId"] }, options: 
{
  query?: Partial<QueryObserverOptions<ResponseConfig<GetLeadByExternalIdQueryResponse>, ResponseErrorConfig<GetLeadByExternalId401 | GetLeadByExternalId403 | GetLeadByExternalId404 | GetLeadByExternalId503>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getLeadByExternalIdQueryKey({ externalId })
         

         const query = useQuery({
          ...getLeadByExternalIdQueryOptions({ externalId }, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetLeadByExternalId401 | GetLeadByExternalId403 | GetLeadByExternalId404 | GetLeadByExternalId503>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}